import Script from 'next/script';

export default function NeedleScript() {
  return (
    <Script
      id="needle-script"
      async
      dangerouslySetInnerHTML={{
        __html: `
          var needleParam = needleParam || {};
          Needle = {onload: window.onload};
          window.onload = function() {
              var e = document.createElement("script");
              e.id = "needle-script-load"
              e.type = "text/javascript";
              e.defer = true;
              e.async = true;
              e.src = "//pyramydair.needle.com/needle_service.js?v=1";
              document.body.appendChild(e);
              if (typeof Needle.onload != "undefined" && Needle.onload !== null) Needle.onload();
          };
        `,
      }}
    />
  );
}
